import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index/Index'

Vue.use(VueRouter)

const routes = [{
		path: "/",
		name: "Index",
		component: () => import("@/views/Index/Index"),
	},
	{
		path: "/Activity",
		name: "Activity",
		component: () => import("@/views/Activity/Activity"),
	},
	{
		path: "/ActivityDetail",
		name: "ActivityDetail",
		component: () => import("@/views/ActivityDetail/ActivityDetail"),
	},
	{
		path: "/Application",
		name: "Application",
		component: () => import("@/views/Application/Application"),
	},
	{
		path: "/Singin",
		name: "Singin",
		component: () => import("@/views/Singin/Singin"),
	},
]

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
